import { supportActivityQuery } from "../lib/supportActivityQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useSupportActivityQuery(...args: Parameters<typeof supportActivityQuery>) {
  return useDashboardQuery(supportActivityQuery(...args))
}
